import React, { forwardRef } from 'react';

export const FullNameInput = forwardRef(({ value, onChange, disabled, error }, ref) => {
  return (
    <div className="form-group">
      <label htmlFor="name">Nome Completo:</label>
      <input
        type="text"
        id="name"
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={error ? 'invalid' : ''}
        ref={ref} 
      />
      {error && <div className="error-message">{error}</div>}
    </div>
  );
});


